<template>
  <div>
    <div class="icon-nav">
      <ul>
        <li class="onhover-div mobile-cart">
          <router-link :to="{ path: '/shop'}" class="footer-shop">
            <div class="text-center">
              <font-awesome-icon icon="fa-solid fa-shop" />
            </div>
            <h6 class="cart-label text-center">Shop</h6>
          </router-link>
          <router-link :to="{ path: '/shop/cart'}" class="footer-bag">
            <div class="text-center">
              <img alt :src='"@/assets/images/icon/layout4/cart.png"' class="img-fluid cart-bag">
              <font-awesome-icon icon="fa-solid fa-cart-shopping" />
              <span class="cart_qty_cls">{{cart_qty}}</span>
            </div>
            <h6 class="cart-label text-center">My Bag</h6>
          </router-link>
          <router-link :to="{ path: '/account/rewards'}">
            <div class="referals">
              <h6><font-awesome-icon icon="fa-solid fa-sack-dollar" /></h6>
              <h6 class="cart-label">Referals</h6>
            </div>
          </router-link>


        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      currencyChange: {},
      search: false,
      searchString: '',
      isShow: false
    }
  },
  computed: {
    ...mapState({
      searchItems: state => state.products.searchProduct
    }),
    ...mapGetters({
      cart: 'cart/cartItems',
      cartTotal: 'cart/cartTotalAmount',
      subTotal: 'cart/subTotalAmount',
      curr: 'products/changeCurrency',
      getDetail: 'products/getProductByProductId'
    }),
    cart_qty: function () {
      // Count all qty but exclude the reward counts
      let qty_count = 0;
      this.cart.forEach(item => {
        if(item.isrewarditem === 0) {
          qty_count += parseInt(item.qty, 10);
        }
      });
      return qty_count;
    },
  },
  methods: {
    openSearch() {
      // this.search = true
    },
    closeSearch() {
      this.search = false;
    },
    searchProduct() {
      this.$store.dispatch('products/searchProduct', this.searchString)
    },
    updateCurrency: function (currency, currSymbol) {
      this.currencyChange = { curr: currency, symbol: currSymbol }
      this.$store.dispatch('products/changeCurrency', this.currencyChange)
    }
  }
}

</script>
